import { combineReducers } from "@reduxjs/toolkit";
import auth from "./auth";
import basicQuestions from "./basic-questions";
import countData from "./count-data";
import flashes from "./flashes";
import globals from "./globals";
import note from "./note";
import procedures from "./procedures";
import questions from "./questions";
import segments from "./segments";
import statements from "./statements";
import ui from "./ui";

export const reducer = combineReducers({
	auth,
	flashes,
	globals,
	segments,
	note,
	questions,
	basicQuestions,
	procedures,
	statements,
	ui,
	countData,
});

export default reducer;
